/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChiusuraDTO } from './chiusuraDTO';

export interface CalendarioDTO { 
    id?: string;
    anno_di_riferimento?: string;
    data_inizio?: string;
    data_fine?: string;
    chiusure_scolastiche?: Array<ChiusuraDTO>;
}